// settings for faq tabs

export const faqTabs = () => {
  const faqTabControllers = document.querySelectorAll('.js-tab-controller');
  const faqTabEls = document.querySelectorAll('.js-tab');

  console.log('it no works');
  if (faqTabControllers.length <= 0 || faqTabEls.length <= 0) return;

  faqTabControllers.forEach((faqTabController, index) => {
    faqTabController.addEventListener('click', (e) => {
      e.preventDefault();
      faqTabEls.forEach((el) => {
        el.classList.remove('active');
      });
      faqTabControllers.forEach((ctrl) => {
        ctrl.classList.remove('active');
      });
      faqTabEls[index].classList.add('active');
      faqTabControllers[index].classList.add('active');
    });
  });
};

export const faqAccordion = () => {
  const faqAccordionTriggers = document.querySelectorAll(
    '.js-accordion-trigger'
  );

  if (faqAccordionTriggers.length <= 0) return;

  faqAccordionTriggers.forEach((faqAccordionTrigger, index) => {
    faqAccordionTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      // @ts-ignore
      faqAccordionTriggers[index]
        .closest('.ri__faq-item')
        .classList.toggle('active');
    });
  });
};
